import { createContext } from 'react';
import type { LoginRequest, User } from '@/types/auth';

export type AuthContextValue = {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
  login: (credentials: LoginRequest) => Promise<void>;
  logout: () => Promise<void>;
  /** Replace the cached current user (e.g. after a profile edit). */
  updateUser: (user: User) => void;
  clearError: () => void;
};

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
